import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import SelectCustomField from "../../form/selectField/selectCustomField";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import ErrorMsg from "../../form/errorMsg";
import Select from "react-select";
import {
  customerSendMail,
  fetchCustomerHeadQuatrer,
} from "../../../redux/actions/customerActions";
import { useDispatch } from "react-redux";
import SendToExecutiveModal from "./sendMailExecutiveModal";
import { useParams } from "react-router-dom";
import ChangeSaved from "../../popups/ChangeSaved";
import ErrorPopup from "../../popups/ErrorPopup";

const UpdateToExecutiveModal = ({ show, ShowClose, data, divisiondata }) => {
  const [HQList, setHQList] = useState([]);
  const [updatedData, setUpdatedData] = useState(null);
  const [sendMailOpen, setSendMailOpen] = useState(false);
  const dispatch = useDispatch();
  const params = useParams();
  useEffect(() => {
    if (show) {
      dispatch(
        fetchCustomerHeadQuatrer(data?.state?.id, onGetHQSuccess, onGetHQError)
      );
    }
  }, [show]);

  const onGetHQSuccess = (data) => {
    console.log(data);
    let newArr = data.data.data.map((ele) => ({
      value: ele?.id,
      label: ele?.name,
    }));
    console.log(newArr, "hq");
    setHQList(newArr);
  };

  const onGetHQError = (err) => {
    console.log(err);
  };

  const initialValues = {
    vendor_subscribe_id: params?.id,
    division_id: divisiondata?.vendorDivision?.id,
    customer_type: divisiondata?.customer_type,
    state_id: data?.state?.id,
    district_id: data?.district?.id,
    head_quater_id: "",
  };
  const validationSchema = Yup.object().shape({
    head_quater_id: Yup.string().required("Required"),
  });
  const onSubmit = (values) => {
    console.log(values);
    dispatch(customerSendMail(values, onSuccess, onError));
  };

  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [onSuccessShow, onSetSuccessShow] = useState(false);
  const [onSuccessMsg, onSetSuccessMsg] = useState("");
  console.log(data, "datatatata");

  const timeOutFnc = () => {
    onSetSuccessShow(false);
    ShowClose();
  };
  const onSuccess = (data) => {
    console.log(data);
    onSetSuccessShow(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    onSetSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };
  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    ShowClose();
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={ShowClose}
        contentClassName="link-modal col-5 mx-auto p-2 fn_Nunito"
      >
        <div className="m-2">
          <div className="fn_Nunito fs_18 mt-3 ms-2 fw_900">
            <h2>Update to Executive</h2>
          </div>

          <ModalBody>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              enableReinitialize={true}
            >
              {({ setFieldValue, values }) => (
                <Form>
                  <div className="d-flex flex-column justify-content-start align-items-start">
                    <div className="fn_Nunito fs_14">
                      <label className="color_747f9e">Division</label>
                      <p className="color_2623cb">
                        {divisiondata?.vendorDivision?.name}
                      </p>
                    </div>
                    <div className="fn_Nunito fs_14">
                      <label className="color_747f9e">State</label>
                      <p className="color_2623cb">{data?.state?.name}</p>
                    </div>
                    <div className="fn_Nunito fs_14">
                      <label className="color_747f9e">District</label>
                      <p className="color_2623cb">{data?.district?.name}</p>
                    </div>
                    <div className="w-100">
                      <SelectCustomField
                        label={"Head Quarters"}
                        labelColor={"color_262c3d"}
                        placeholder={"Select head quarter"}
                        optionList={HQList}
                        name={"head_quater_id"}
                        id={"head_quater_id"}
                        menuHeight="130px"
                        value={""}
                      />
                    </div>
                  </div>

                  <div className=" d-flex m-1 ">
                    <AdminButton
                      width="266px"
                      height="52px"
                      type="button"
                      color="#FF6F5B"
                      border="1px solid #FF6F5B"
                      onClick={() => ShowClose()}
                    >
                      <span className="m-2">CANCEL</span>
                    </AdminButton>
                    <AdminButton
                      width="266px"
                      height="52px"
                      type="submit"
                      background="#7065E4"
                      border-radius="5px"
                      color="white"
                    >
                      SEND MAIL
                    </AdminButton>
                  </div>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </div>
      </Modal>
      <ChangeSaved show={onSuccessShow} title={onSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
      {/* <SendToExecutiveModal
        HQList={HQList}
        data={updatedData}
        show={sendMailOpen}
        ShowClose={() => setSendMailOpen(false)}
      /> */}
    </>
  );
};

export default UpdateToExecutiveModal;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    // height: "43px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
